<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24">
    <path
      d="M8.375 2.25v1.636h8.25V2.25h1.65v1.636h.825c.907 0 1.65.737 1.65 1.637v13.09c0 .9-.742 1.637-1.65 1.637H5.9c-.908 0-1.65-.736-1.65-1.636V5.523c0-.9.742-1.637 1.65-1.637h.825V2.25h1.65zM19.1 7.977H5.9v10.637h13.2V7.977zm-1.35 7.773v1.5h-1.5v-1.5h1.5z"
      :fill="disabled ? '#ccccc9' : color"
      fill-rule="evenodd"
    />
  </svg>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#1D1D20',
    },
    size: {
      type: String,
      default: '24',
    },
  },
}
</script>
